import { useEffect } from "react";
import { formattedNumber } from "../../views/popups/phonenumbers/AddRemoveNumbers";
/**
 * Filters data based on a raw search value and specified object fields.
 *
 * @param {Array} data - The array of data to search.
 * @param {string} searchValue - The raw (untrimmed) search input.
 * @param {string[]} fields - The fields to search in each object.
 * @returns {Array} Filtered data.
 */
export const customSearch = (data, searchValue, fields) => {
  try {
    const trimmedValue = searchValue.trim().toLowerCase();
    if (!trimmedValue) return data;

    return data.filter((item) =>
      fields.some((field) => {
        const fieldValue = String(item?.[field] ?? "").toLowerCase();
        return fieldValue.includes(trimmedValue);
      })
    );

  } catch (error) {
    console.error("customSearch error:", error);
    return data;
  }
};

// DropDown related search

export const customSearchFn = (query, data) =>{

  try {
    if (!query) return data;

    const searchWords = query.toLowerCase().split(/\s+/).filter(Boolean);

    return data.filter((opt) => {
      const words = opt.text.toLowerCase().split(/\s+/); // split into words

      if (searchWords.length === 1) {
        return words.some((w) => w.startsWith(searchWords[0]))
      }
      else {
        for (let i = 0; i <= words.length - searchWords.length; i++) {
          let match = true;
          for (let j = 0; j< searchWords.length; j++) {
            if (!words[i + j].startsWith(searchWords[j])) { // exact match
              match = false;
              break;
            }
          }
          if (match) return true;
        }
        return false;

      }
    });
    
  } catch (error) {
    console.error("Error in customSearchFn:", error);
    return data; // fallback to returning unfiltered data
  }
};
export const customSearchNumbers = (numbersArray, query) => {
  if (!query) return numbersArray;

  const normalize = (str) => str?.replace(/[+\s-]/g, "").toLowerCase() || "";
  const queryNorm = normalize(query);

  return numbersArray.filter((num) =>
    normalize(num).includes(queryNorm)
  );
};
export const useAutoFocusSearchAfterLoads = (dataLoaded, setDataLoaded, ref, isActive) => {
  useEffect(() => {
    console.log("useAutoFocusSearchAfterLoads params =>", { dataLoaded, setDataLoaded, ref, isActive});
    if (dataLoaded) {
      const timer = setTimeout(() => {
        try {
          ref.current?.focus();
          setDataLoaded(false);
        } catch (error) {
          console.error("AutoFocus failed:", error);
        }
      }, 200);

      return () => clearTimeout(timer);
    }
  }, [dataLoaded, ref, isActive, setDataLoaded]);
};
